import { SORTING_VALUES } from 'shared/constants/sorting-values';

export const isValidSortingValue = (value: string) => {
  return value in SORTING_VALUES;
};
